import { GroupShiftProfile } from "pages/web/scheduleRules/subpages/GroupShiftProfile";
import { ShiftProfile } from "pages/web/scheduleRules/subpages/ShiftProfile";
import { ScheduleRules } from "pages/web/scheduleRules/subpages/ScheduleRules";
import { Resume } from "pages/web/scheduleRules/subpages/resume/Resume";

const gettingSubPage = (subPage: string) => {
    switch (subPage) {
        case 'resume':
            return <Resume />;

        case 'group-shift-profile':
            return <GroupShiftProfile />;

        case 'schedule-rules':
            return <ScheduleRules />;

        case 'shift-profile':
            return <ShiftProfile />;

        default:
            return <> {`404 Subpage ${subPage} not found`} </>
    }
}

export { gettingSubPage };